import React from 'react';
import { HiringManager } from '../types';

export interface HiringManagerInputProps {
    hiringManager: HiringManager;
    onChange: (hiringManager: HiringManager) => void;
}

class ShareWithHiringManagerInput extends React.Component<HiringManagerInputProps, any> {
    private emailRef: React.RefObject<HTMLInputElement>;

    public constructor(props) {
        super(props);
        this.emailRef = React.createRef();
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    private changeEmail(text: string) {
        if (this.props.hiringManager.email !== text) {
            this.props.onChange({ ...this.props.hiringManager, email: text });
            if (this.props.hiringManager.email === '' && this.emailRef.current) {
                this.emailRef.current.value = '';
                this.emailRef.current.focus();
            }
        }
    }

    private handleOnChange(event) {
        const text = event.currentTarget.value;
        this.changeEmail(text);
    }

    private handleKeyPress = e => {
        if (this.emailRef.current) {
            if (e.key === 'Enter') {
                this.changeEmail(this.emailRef.current.value);
            } else if (e.keyCode === 27) {
                // on esc pressed
                this.emailRef.current.value = this.props.hiringManager.email;
            }
        }
    };

    public render() {
        const placeholder =
            this.props.hiringManager.email === '' ? 'Add new hiring manager email...' : 'Remove this hiring manager';
        return (
            <input
                key={this.props.hiringManager.email}
                style={{ width: '20em' }}
                name="email"
                defaultValue={this.props.hiringManager.email}
                ref={this.emailRef}
                placeholder={placeholder}
                onBlur={this.handleOnChange}
                onKeyPress={this.handleKeyPress}
                onKeyDown={this.handleKeyPress}
            />
        );
    }
}

export default ShareWithHiringManagerInput;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/ShareWithHiringManagerInput.tsx